import "../components/style/index.css";
import Footer from './../components/Footer'
import TopNavbar from '../components/Navbar/TopNavbar';
import ContentQuestions from '../components/ContentQuestions';

function Home() {
  return (
    <div className='d-flex flex-column'>
      <TopNavbar/>
      <ContentQuestions />
      <Footer />
    </div>
  );
}

export default Home;